module.exports = {"id":"183900","name":"Diego Perotti","rating":"81","photo":"./data/images/photos/1/183900.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["AG","ATT"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoPerotti0.json
// module id = 1092
// module chunks = 0